import { render } from "./PublicationsView.vue?vue&type=template&id=7bf6edab"
import script from "./PublicationsView.vue?vue&type=script&lang=js"
export * from "./PublicationsView.vue?vue&type=script&lang=js"

import "./PublicationsView.vue?vue&type=style&index=0&id=7bf6edab&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__